module.exports = __webpack_public_path__ + "img/sol3.49883eea.png";